import { all, call, put, takeEvery } from "redux-saga/effects";
import enderecoService from "../../commons/services/endereco";
import { flow } from "../modules/flow";
import { actions, types } from "../modules/endereco";

export default function* enderecoSaga() {
  yield takeEvery(types.ADDRESS_SEARCH, searchAddress);
  yield takeEvery(types.ESTADOS, getEstados);
  yield takeEvery(types.CIDADES, getCidades);
  yield takeEvery(types.PROVINCIAS, getProvincias);
  yield takeEvery(types.TIPOS_VIA, getTiposVia);
}

function* searchAddress(action) {
  yield* flow({
    type: action.type,

    fnTry: function* () {
      const [data] = yield all([
        call(() => enderecoService.searchAddress(action.payload)),
      ]);

      yield put(actions.updateAddressStore(data));

      const { callback } = action.payload;

      // callback
      if (callback && typeof callback === "function") {
        callback();
      }
    },

    fnCatch: function* () {
      // não exibir mensagem de erro...
      yield put(actions.updateAddressStore({}));

      const { callback } = action.payload;

      // callback
      if (callback && typeof callback === "function") {
        callback();
      }
    },
  });
}

function* getEstados(action) {
  yield* flow({
    type: action.type,

    fnTry: function* () {
      const [data] = yield all([
        call(() => enderecoService.getEstados(action.payload)),
      ]);

      const { callback } = action.payload;

      // callback
      if (callback && typeof callback === "function") {
        callback(data);
      }
    },
  });
}

function* getCidades(action) {
  yield* flow({
    type: action.type,

    fnTry: function* () {
      const [data] = yield all([
        call(() => (action.payload.provincia) ? enderecoService.getCidadesByProvincia(action.payload) : enderecoService.getCidadesByUf(action.payload)),
      ]);

      const { callback } = action.payload;

      // callback
      if (callback && typeof callback === "function") {
        callback(data);
      }
    },
  });
}

function* getProvincias(action) {
  yield* flow({
    type: action.type,

    fnTry: function* () {
      const [data] = yield all([
        call(() => enderecoService.getProvincias(action.payload)),
      ]);

      const { callback } = action.payload;

      // callback
      if (callback && typeof callback === "function") {
        callback(data);
      }
    },
  });
}

function* getTiposVia(action) {
  yield* flow({
    type: action.type,

    fnTry: function* () {
      const [data] = yield all([
        call(() => enderecoService.getTiposVia(action.payload)),
      ]);

      const { callback } = action.payload;

      // callback
      if (callback && typeof callback === "function") {
        callback(data);
      }
    },
  });
}